/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ExternalSourceVastFactory from './external-source-vast/external-source-vast-factory';

/**
 * @import { IMediumExternalSourceFactory, IExternalSourceFactory } from "."
 * @import AudienceMultiplierResolver from '../audience-multiplicator/audience-multiplier-resolver'
 * @import { ContentInfo } from '../content/info/content-info'
 * @import { Medium } from "../medium/medium"
 * @import { IVariablesNamespaceRegistry } from '../variables'
 */

/**
 * @implements {IMediumExternalSourceFactory}
 */
export default class MediumExternalSourceFactory {
  /**
   * @param {AudienceMultiplierResolver} audienceMultiplierResolver
   * @param {IVariablesNamespaceRegistry} variablesNamespaceRegistry
   */
  constructor(audienceMultiplierResolver, variablesNamespaceRegistry) {
    this.audienceMultiplierResolver = audienceMultiplierResolver;
    this.variablesNamespaceRegistry = variablesNamespaceRegistry;
    this.perRequestChainBudgetMs = 15000;
    this.totalChainBudgetMs = 15000;
  }

  /**
   * @private
   * @param {ContentInfo} contentInfo
   * @param {Medium} medium
   * @returns {IExternalSourceFactory}
   */
  createExternalSourceFactory(contentInfo, medium) {
    const { params } = medium;
    let externalSourceFactory;
    switch (params?.sourceType) {
      case 'vast':
        externalSourceFactory = new ExternalSourceVastFactory(
          this.audienceMultiplierResolver.get(contentInfo),
          this.variablesNamespaceRegistry,
          {
            totalTimeoutBudgetMs: this.totalChainBudgetMs,
            perRequestTimeoutMs: this.perRequestChainBudgetMs
          }
        );
        break;
      default:
        throw new Error(`sourceType "${params?.sourceType}" is not supported`);
    }
    return externalSourceFactory;
  }

  /** @type {IMediumExternalSourceFactory['createFactory']} */
  createFactory(contentInfo, medium) {
    // TODO: zaobalení do CachingFacade
    return this.createExternalSourceFactory(contentInfo, medium);
  }
}
